import Input from './input'

export default Input.withComponent('textarea').extend`
  height: 160px;
  resize: vertical;
`



// WEBPACK FOOTER //
// ./components/atoms/textarea.js